<template>
  <div class="companyInformationView-all-box clearfix userListAddMain">
    <card>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      class="demo-ruleForm clearfix"
      label-position="left"
    >
      <el-form-item prop="input1">
        <div class="title-name">{{ $t('queryForm.userName') }}<span>*</span></div>
        <el-input v-model="ruleForm.input1" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
      </el-form-item>

      <el-form-item prop="input2">
        <div class="title-name">{{ $t('queryForm.companyEmail') }}<span>*</span></div>
        <el-input v-model="ruleForm.input2" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1 || isdis == 2 " />
      </el-form-item>

      <el-form-item prop="input3">
        <div class="title-name">{{ $t('queryForm.companyName') }}<span>*</span></div>
        <el-select v-model="ruleForm.input3" :placeholder="$t('queryForm.pleaseSelect')" :disabled="isdis == 1 || isdis == 2 ">  
          <el-option
            v-for="item in commonList"
            :key="item.ids"
            :label="item.text"
            :value="item.ids"
          />
        </el-select>
      </el-form-item>

      <el-form-item prop="input4">
        <div class="title-name">{{ $t('formData.telephone') }}</div>
        <el-input v-model="ruleForm.input4" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
      </el-form-item>

      <el-form-item prop="input5">
        <div class="title-name">{{ $t('administration.Usermobilephone') }}</div>
        <el-input v-model="ruleForm.input5" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
      </el-form-item>

      <!-- <el-form-item prop="input6">
        <div class="title-name">{{ $t('administration.customertype') }}<span>*</span></div>
        <el-select v-model="ruleForm.input6" :placeholder="$t('queryForm.pleaseSelect')" :disabled="isdis == 1 || isdis == 2 ">
          <el-option :label="$t('administration.Superadministrator')" value="0" />
          <el-option :label="$t('administration.system')" value="1" />
          <el-option :label="$t('administration.company')" value="2" />
          <el-option :label="$t('administration.project')" value="3" />
          <el-option :label="$t('administration.patent')" value="4" />
        </el-select>
      </el-form-item> -->

      <el-form-item prop="input9" class="line phoneImg" style="margin-bottom: 107px;">
        <div class="title-name">{{ $t('administration.userPhoto') }}</div>
        <el-upload
          class="avatar-uploader"
          :action= 'urlImg'
          accept=".jpg,.png,.jpeg,.gif,.tif,.bmp"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :disabled="isdis == 1"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
      </el-form-item>

      <!-- <el-form-item prop="input7" class="line">
        <div class="title-name">{{ $t('administration.role') }}<span>*</span></div>
        <template>
          <el-checkbox-group v-model="ruleForm.input7" :disabled="isdis == 1">
            <el-checkbox v-for="item in roleList" :key="item.ids" :label="item.ids">{{ item.text }}</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-form-item> -->

      <el-form-item prop="roleId">
        <div class="title-name">{{ $t('administration.role') }}<span>*</span></div>
        <el-select v-model="ruleForm.roleId" :placeholder="$t('queryForm.pleaseSelect')" :disabled="isdis == 1">  
          <el-option
            v-for="item in roleList"
            :key="item.ids"
            :label="item.text"
            :value="item.ids"
          />
        </el-select>
      </el-form-item>

      <el-form-item prop="input8">
        <div class="title-name">{{ $t('queryForm.status') }}<span>*</span></div>
        <template>
          <el-radio v-model="ruleForm.input8" label="1" :disabled="isdis == 1">{{ $t('button.enable') }}</el-radio>
          <el-radio v-model="ruleForm.input8" label="0" :disabled="isdis == 1">{{ $t('button.disable') }}</el-radio>
        </template>
      </el-form-item>


      <el-form-item prop="input10" class="line">
        <div class="title-name">{{ $t('formData.remarks') }}</div>
        <el-input v-model="ruleForm.input10" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
      </el-form-item>

      <el-form-item class="line btn-box input-form-btn-list">
        <!-- <el-button type="primary" plain @click="cancel">Cancel</el-button>
        <el-button v-if="isdis !== 1" type="primary" round @click="submissionBtn('ruleForm')">Save</el-button> -->
        <cus-btn type="cancel" @click="cancel()"></cus-btn>
        <cus-btn type="save" v-if="isdis !== 1" :disabled='isdisabled' @click="submissionBtn('ruleForm')"></cus-btn>
      </el-form-item>
    </el-form>
    </card>
  </div>
</template>

<script>
import { roleAllSelect, baseEnumsSelectCommon, userSave, userDetail, userUpdate } from '../../api/adminManagement'
import { MessageBox, Message } from 'element-ui'
import axios from "axios";
export default {
  name: 'CompanyInformationView',
  components: {},
  data() {
    return {
      ruleForm: {
        fileList: [],
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: [],
        input8: '1',
        input9: '',
        input10: '',
        roleId: ''
      },
      // rules: {
      //   input1: [{ required: true, message: '请输入', trigger: 'blur' }],
      //   input2: [{ required: true, message: '请输入', trigger: 'blur' }],
      //   input3: [{ required: true, message: '请输入', trigger: 'change' }],
      //   input4: [{ required: true, message: '请输入', trigger: 'blur' }],
      //   input5: [{ required: true, message: '请输入', trigger: 'blur' }],
      //   input6: [{ required: true, message: '请输入', trigger: 'change' }],
      //   input7: [{ required: true, message: '请输入', trigger: 'change' }],
      //   input8: [{ required: true, message: '请输入', trigger: 'change' }],
      //   // input9: [{ required: true, message: '请输入', trigger: 'change' }],
      //   // input10: [{ required: true, message: '请输入', trigger: 'blur' }]

      // },
      imageUrl: '',
      roleList: [], // 角色
      commonList: [],
      isdis: '',
      urlImg:'',
      isdisabled:false
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    },
    rules(){
      return {
        input1: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        input2: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        input3: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        // input4: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        // input5: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        input6: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        input7: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        input8: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        // input9: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        // input10: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        roleId: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }]
      }
    }
  },
  watch: {
    lang() {
      this.getroleAllSelect()
      this.getbaseEnumsSelectCommon()
    }
  },
  mounted() {
    this.urlImg = axios.defaults.baseURL + '/common/file/upload'
    this.getroleAllSelect()
    this.getbaseEnumsSelectCommon()
    if (this.$route.params.id) {
      this.isdis = this.$route.params.type
      this.subUserdetail()
    }
    // window.companyInformationView = self
  },
  methods: {
    handleChange(file, fileList) {
      this.ruleForm.fileList = fileList.slice(-3)
    },

    /**
     * 返回上一页
     */
    cancel() {
      this.$router.push({
        name: 'userList'
      })
    },

    /**
     * 图片上传
     */
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw)
      this.imageUrl = res.data.path
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg'
      // const isPNG = file.type === 'image/png'    .jpg,.png,.jpeg,.gif,.tif,.bmp
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
            const extension = testmsg === 'jpg'
            const extension2 = testmsg === 'png'
            const extension3 = testmsg === 'jpeg'
            const extension4 = testmsg === 'gif'
            const extension5 = testmsg === 'tif'
            const extension6 = testmsg === 'bmp'
      const isLt2M = file.size / 1024 / 1024 < 10

      if(!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 ) {
          this.$message.error(this.$t("administration.format"))
      }

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG和PNG 格式!')
      // }
      // if (!isPNG) {
      //   this.$message.error('上传头像图片只能是 JPG和PNG 格式!')
      // }
      if (!isLt2M) {
        this.$message.error(this.$t("administration.uploadedpicture"))
      }
      // return isJPG && isPNG && isLt2M
      return  isLt2M
    },

    // 获取角色
    getroleAllSelect() {
      const self = this
      self.roleList = []
      let invoicetypeMap = {}
      roleAllSelect({}).then(response => {
        if (response.code === 200) {
          response.data.forEach(item => {
            invoicetypeMap = {
              text: item.name,
              ids: item.id
            }
            self.roleList.push(invoicetypeMap)
          })
        }
      })
    },

    // 获取公司枚举
    getbaseEnumsSelectCommon() {
      const self = this
      self.commonList = []
      let invoicetypeMap = {}
      baseEnumsSelectCommon({}).then(response => {
        if (response.code === 200) {
          response.data.forEach(item => {
            invoicetypeMap = {
              text: item.companyName,
              ids: item.id
            }
            self.commonList.push(invoicetypeMap)
          })
        }
      })
    },

    // 账号提交
    submissionBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const self = this
          let param
          // if( self.imageUrl == ''){
          //     Message({
          //       message: this.$t("administration.PleaseuserAvatar"),
          //       type: 'error',
          //       duration: 5 * 1000
          //     })
          //     return
          // }
          // if( self.ruleForm.input5 ){
          //   var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
          //   if (!myreg.test(self.ruleForm.input5)) {
          //     Message({
          //       message: this.$t("administration.Incorrectmobilenumber"),
          //       type: 'error',
          //       duration: 5 * 1000
          //     })
          //     return
          //   }

          // }
          this.isdisabled = true
          if (this.isdis == 2) {
            //  修改
            param = {
              name: self.ruleForm.input1, // 用户名称
              telephone: self.ruleForm.input4, // 用户固化
              mobile: self.ruleForm.input5, // 用户手机
              remarks: self.ruleForm.input10, // 用户备注
              photo: self.imageUrl, // 用户头像
              // roleIds: self.ruleForm.input7, // 角色id集合
              status: self.ruleForm.input8, // 状态
              companyId: self.ruleForm.input3,
              email: self.ruleForm.input2, // 用户邮箱
              type: self.ruleForm.input6, // 账号类型
              id: self.$route.params.id, // id
              roleIds: [self.ruleForm.roleId]// 角色id集合
            }
            userUpdate(param)
              .then(response => {
                if (response.code === 200) {
                  this.$message({
                    message: response.message,
                    type: 'success'
                  })
                  this.isdisabled = false
                  this.$router.push({
                    name: 'userList'
                  })
                }else{
                  this.isdisabled = false
                }
              })
          } else {
            //  新增
            param = {
              email: self.ruleForm.input2, // 用户邮箱
              name: self.ruleForm.input1, // 用户名称
              companyId: self.ruleForm.input3, // 公司ID
              type: self.ruleForm.input6, // 账号类型
              telephone: self.ruleForm.input4, // 用户固化
              mobile: self.ruleForm.input5, // 用户手机
              remarks: self.ruleForm.input10, // 用户备注
              photo: self.imageUrl, // 用户头像
              // roleIds: self.ruleForm.input7, // 角色id集合
              status: self.ruleForm.input8, // 状态
              roleIds: [self.ruleForm.roleId]// 角色id集合
            }
            userSave(param)
              .then(response => {
                if (response.code === 200) {
                  this.$message({
                    message: response.message,
                    type: 'success'
                  })
                  this.isdisabled = false
                  this.$router.push({
                    name: 'userList'
                  })
                }else{
                  this.isdisabled = false
                }
              })
          }
        }
      })
    },

    // 账户信息查看
    subUserdetail() {
      const self = this
      const param = {
        id: self.$route.params.id // id
      }
      userDetail(param)
        .then(response => {
          if (response.code === 200) {
            self.ruleForm.input2 = response.data.email // 用户邮箱
            self.ruleForm.input1 = response.data.name // 用户名称
            self.ruleForm.input3 = parseInt(response.data.compantId) // 公司ID
            self.ruleForm.input6 = response.data.type // 账号类型
            self.ruleForm.input4 = response.data.telephone // 用户固化
            self.ruleForm.input5 = response.data.mobile // 用户手机
            self.ruleForm.input10 = response.data.remarks // 用户备注
            self.imageUrl = response.data.photo // 用户头像
            self.ruleForm.input7 = response.data.roleIds // 角色id集合
            self.ruleForm.input8 = response.data.status // 状态
            self.ruleForm.roleId = (response.data.roleIds && response.data.roleIds.length > 0) ? response.data.roleIds[0] : ''// 角色id
          }
        })
    }

  }
}
</script>

<style scoped lang="scss">
.companyInformationView-all-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding-top: 30px;
  margin-bottom: 90px;
}

</style>
<style lang="scss">
  .userListAddMain{
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 90px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .avatar {
      width: 90px;
      height: 90px;
      display: block;
    }
    .phoneImg{
      position: relative;
      .avatar-uploader{
        position: absolute;
      }
    }

  }

</style>
